import React from 'react'
import i18n from "../constants/i18n";
import { Button,Modal } from "react-bootstrap";
function PopUp(props) {
    return (props.showPopUp) ? (
        <Modal size ={props.modalSize} contentClassName= {props.modalStyle} show={props.showPopUp} onHide={() => props.setShowPopUp(false)}  >
             { props.modalHeader ?  
            <Modal.Header style={{borderBottom:'none', paddingTop:'3rem'}}>
                <div style={{width:'100%' ,display:'flex', justifyContent:'flex-end', alignItems:'center'}}>
                    <Button variant="flat" className={'btn-flat'} onClick = {() => props.setShowPopUp(false)}><b className = {props.closeBtnStyle}>x</b></Button>
                </div>
            </Modal.Header>
            :null}
            <Modal.Body  >
                {props.children}
            </Modal.Body>
        
      </Modal>
    ) : '';

}

export default PopUp
